import { render, staticRenderFns } from "./UICheckboxDisabled.vue?vue&type=template&id=32c2a748"
import script from "./UICheckboxDisabled.vue?vue&type=script&lang=js"
export * from "./UICheckboxDisabled.vue?vue&type=script&lang=js"
import style0 from "./UICheckboxDisabled.vue?vue&type=style&index=0&id=32c2a748&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports